define(function () {
	var base_collection = require('./nearest_collection_base');

	return base_collection.extend({
		siteType:'parcel',
		urlRoot: '/delegate/civics-api/api/property/parcels?TryCenterPoint={5}&MapExtent={Min:{X:{0},Y:{1}},Max:{X:{2},Y:{3}}}&page=[{Start:1,Max:0}]&IsEffective=true&IsExpired=false',
		url: function () {
			let url = base_collection.prototype.url.apply(this, arguments);

			// Set tryCenterPoint to false if it's undefined
			this.tryCenterPoint = this.tryCenterPoint !== undefined ? this.tryCenterPoint : false;

			//the first 4 elements were already replaced via the prototype URL applying the extent.
			url = url.format(null, null, null, null, this.maxSitesCount, this.tryCenterPoint);
 			
			return url;
		}
	});
});
